module.exports = __webpack_public_path__ + "static/assets/d0b9d97561599bfc922cdb2a6cba895b.svg";